import React from 'react';
import TenantStatusBadge from './TenantStatusBadge';

const TenantListPanel = ({ tenants = [], selectedTenantId, onSelectTenant }) => (
  <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-3">
    <h3 className="mb-3 text-sm font-semibold text-slate-100">Daftar Tenant</h3>
    <div className="space-y-2">
      {tenants.map((tenant) => {
        const active = String(selectedTenantId || '') === String(tenant.tenantId || '');
        return (
          <button
            key={tenant.tenantId}
            type="button"
            onClick={() => onSelectTenant(tenant.tenantId)}
            className={`w-full rounded-lg border px-3 py-2 text-left text-xs ${active ? 'border-cyan-500/60 bg-cyan-500/10' : 'border-slate-800 bg-slate-950/60'}`}
          >
            <div className="flex items-center justify-between gap-2">
              <div>
                <div className="font-medium text-slate-100">{tenant.tenantName}</div>
                <div className="text-slate-400">{tenant.tenantId}</div>
              </div>
              <TenantStatusBadge status={tenant.status} />
            </div>
            <div className="mt-1 text-slate-400">Paket: {tenant.plan}</div>
          </button>
        );
      })}
      {!tenants.length ? <div className="text-xs text-slate-500">Tenant tidak ditemukan.</div> : null}
    </div>
  </section>
);

export default TenantListPanel;
